module.exports = __webpack_public_path__ + "static/media/phone-square-alt.e8ccbe67.svg";